(function () {
  'use strict';
  if (window.WPOGoogleAds) return;
  var intakeUrl = 'https://hook.us2.make.com/n9k38i1xfqmixl9pfk4scb84j88ov0ud';
  var sent = new Set();
  var preview = !!(window.Shopify && (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role !== 'main'))) || new URLSearchParams(window.location.search).has('preview_theme_id');
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !preview && !!p && p.marketingAllowed() === true && p.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }
  function eligible(data) {
    if (!data || data.test === true || data.is_test === true) return false;
    var email = String(data.email || '').trim().toLowerCase();
    var notes = String(data.problem_description || '').trim();
    if (!data.first_name || !data.last_name || !data.vehicle_type || email.length < 6 || email.indexOf('@') < 1 || notes.length < 6) return false;
    if (/mailinator\.com|tempmail|10minutemail|@example\.(com|org|net)$/.test(email)) return false;
    if (/http:\/\/|https:\/\/|www\.|seo|backlink|guest post|casino|crypto/i.test(notes)) return false;
    return true;
  }
  function lead(data) {
    try {
      if (!allowed() || !eligible(data)) return;
      if (typeof window.gtag !== 'function') return;
      var id = data.submission_id;
      if (!id || sent.has(id)) return;
      var key = 'wpo_ga_lead_' + id;
      try { if (window.sessionStorage.getItem(key)) return; } catch (e) {}
      window.gtag('event', 'generate_lead', {
        send_to: 'G-GH2ZYFB6P9',
        form_name: String(data.form_type || data.form_name || 'website_inquiry').slice(0, 100),
        page_location: window.location.origin + window.location.pathname,
        page_referrer: '',
        event_id: id
      });
      try {
        if (window.WolfPackTracker && typeof window.WolfPackTracker.recordSubmission === 'function') window.WolfPackTracker.recordSubmission(data);
      } catch (e) {}
      sent.add(id);
      try { window.sessionStorage.setItem(key, '1'); } catch (e) {}
    } catch (e) {}
  }
  window.WPOGoogleAds = { version: 1 };
  var originalFetch = window.fetch;
  window.fetch = function (input, options) {
    var payload = null;
    var consentAtSubmission = false;
    try {
      if (typeof input === 'string' && input === intakeUrl && options && String(options.method).toUpperCase() === 'POST' && typeof options.body === 'string') {
        payload = JSON.parse(options.body);
        consentAtSubmission = allowed();
      }
    } catch (e) {}
    var request = originalFetch.apply(this, arguments);
    if (payload && consentAtSubmission) {
      request.then(function (response) {
        if (response.ok) lead(payload);
      }, function () {}).catch(function () {});
    }
    return request;
  };
  document.addEventListener('click', function (event) {
    try {
      if (!allowed() || typeof window.gtag !== 'function') return;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var url = new URL(link.href, window.location.href);
      var name = url.protocol === 'tel:' ? 'wpo_phone_link_clicked' :
        url.hostname === 'app.shopmonkey.cloud' && url.pathname.indexOf('/public/scheduler/') === 0 ? 'wpo_consult_scheduler_opened' : null;
      if (name) window.gtag('event', name, { send_to: 'G-GH2ZYFB6P9', page_location: window.location.origin + window.location.pathname, page_referrer: '' });
    } catch (e) {}
  });
})();
